var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"none","position":"fixed","margin-top":"50px","top":"50%","left":"50%","min-width":"100%","min-height":"100%","width":"auto","height":"auto","-webkit-transform":"translateX(-50%) translateY(-50%)","transform":"translateX(-50%) translateY(-50%)","background-size":"cover"},attrs:{"src":_vm.linkURL}})
}
var staticRenderFns = []

export { render, staticRenderFns }